import * as React from "react";
import classNames from "classnames";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import WarningIcon from "@material-ui/icons/Warning";
import { withStyles, WithStyles } from "@material-ui/core/styles";

import { styles } from "./Notification.style";
import { Snackbar } from "@material-ui/core";

import { NotificationItem } from "../../types/NotificationItem";

const variantIcon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon,
};

interface NotificationContentProps {
    notification: NotificationItem;
    onClose?();
}

class NotificationContent extends React.Component<NotificationContentProps & WithStyles<typeof styles>> {
    render() {
        const { classes, notification, onClose, ...other } = this.props;
        const Icon = variantIcon[notification.variant];

        return (
            <SnackbarContent
                className={classNames(classes[notification.variant])}
                aria-describedby="client-snackbar"
                message={(
                    <span className={classes.message}>
                        <Icon className={classNames(classes.icon, classes.iconVariant)} />
                        {notification.message}
                    </span>
                )}
                action={onClose ? <IconButton key="close" color="inherit" onClick={onClose}><CloseIcon className={classes.icon} /></IconButton> : null}
                {...other}
            />
        );
    }
}

interface NotificationProps {
    notification: NotificationItem;
    transitionDuration?: number;
    autoHideDuration?: number;
    anchorOrigin?: any;
    onClose?(): void;
}

class Notification extends React.Component<NotificationProps & WithStyles<typeof styles>> {

    componentDidUpdate() {
        if (this.props.notification && this.props.notification.closesAfter) {
            setTimeout(this.props.onClose, this.props.notification.closesAfter);
        }
    }

    render() {
        if (!this.props.notification) return null;
        return (
            <Snackbar
                anchorOrigin={this.props.anchorOrigin ? this.props.anchorOrigin : {
                    vertical: "top",
                    horizontal: "right"
                }}
                open={!!this.props.notification}
                transitionDuration={this.props.transitionDuration !== null ? this.props.transitionDuration : 300}
                autoHideDuration={this.props.autoHideDuration !== null ? this.props.autoHideDuration : 6000}
                onClose={this.props.onClose}
            >
                <NotificationContent
                    classes={this.props.classes}
                    onClose={this.props.onClose}
                    notification={this.props.notification}
                />
            </Snackbar>
        );
    }
}

export default withStyles(styles)(Notification);



// WEBPACK FOOTER //
// ./src/components/Notification/Notification.tsx